import { useIntl } from 'react-intl';

import { Button, Card, Text, TextElements } from '@calm-web/design-system';

import { useAnalytics } from '@/hooks/analytics';
import { useFormattedPriceWithTax } from '@/hooks/purchase/useFormattedPriceWithTax';
import { usePricesState } from '@/hooks/store';

import { conversionMessages, sharedMessages } from '../messages';
import { Headline } from '../styles';
import { CardPadding, LimitedTimeCallout, ProgramDetail, Section } from './styles';

const Conversion = () => {
	const { formatMessage } = useIntl();
	const prices = usePricesState();
	const yearlyPriceWithTax = useFormattedPriceWithTax(prices.current.yearly);
	const monthlyPriceWithTax = useFormattedPriceWithTax(prices.current.yearly / 12);
	const { logEvent } = useAnalytics();

	const logClickCTA = () => {
		logEvent({
			eventName: 'Page : CTA_bottom : Clicked',
			eventProps: {
				type: 'button',
				copy: formatMessage(sharedMessages.sharedCta),
			},
		});
	};
	return (
		<Section>
			<Headline noMargin>{formatMessage(conversionMessages.conversionHeadline)}</Headline>
			<Card noPadding>
				<CardPadding>
					<LimitedTimeCallout>{formatMessage(sharedMessages.sharedSpecialLabel)}</LimitedTimeCallout>
					<Text el={TextElements.H3} color="blue3">
						{formatMessage(conversionMessages.programName)}
					</Text>
					<ProgramDetail>
						{formatMessage(conversionMessages.programDetail, {
							yearlyPrice: yearlyPriceWithTax,
							monthlyPrice: monthlyPriceWithTax,
						})}
					</ProgramDetail>
					<Button
						fullWidth
						href="/signup-flow?source=second_free_trial_offer&focus=second_free_trial"
						backgroundColor="gradientCalmBrand"
						onPress={logClickCTA}
					>
						{formatMessage(sharedMessages.sharedCta)}
					</Button>
				</CardPadding>
			</Card>
		</Section>
	);
};

export default Conversion;
